import { lazy, Suspense } from 'react'

import { LoadingTurbo } from 'atoms'

import { useYourWayScreen } from './useYourWayScreen'
import { YourWayScreenComponent } from './YourWayScreen.types'

const YourWayScreenDesktop = lazy(() => import('./YourWayScreen.desktop'))

const YourWayScreenMobile = lazy(() => import('./YourWayScreen.mobile'))

export const YourWayScreen: YourWayScreenComponent = ({ navigation, route }) => {
  const props = useYourWayScreen({ navigation, route })

  const Screen = props.isMobile ? YourWayScreenMobile : YourWayScreenDesktop

  return (
    <Suspense fallback={<LoadingTurbo />}>
      <Screen {...props} />
    </Suspense>
  )
}
